import { GoogleFontLoader } from 'components/GoogleFontLoader/GoogleFontLoader'
import Styles from './TextEditingDrawer.module.scss'
import { TextPreset } from '../TextTab/Types'
import cx from 'classnames'
import { BlazeFontLoader } from 'components/BlazeFontLoader/BlazeFontLoader'

interface Props {
  preset: TextPreset
  isSelected?: boolean
}

export const TextPresetPreview = ({ preset, isSelected = false }: Props) => (
  <>
    <img
      src={preset.preview}
      alt={preset.props.text}
      className={cx(Styles.textPresetPreviewImage, { [Styles.selected]: isSelected })}
    />
    {preset.props.fontFamily && (
      <>
        <GoogleFontLoader family={preset.props.fontFamily} />
        <BlazeFontLoader name={preset.props.fontFamily} />
      </>
    )}
  </>
)
